import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const articles = [
  {
    to: "/halo/learn/what-is-quantumcloak",
    title: "What is QuantumCloak?",
    body: "How QuantumCloak works with Halo SuperVPN to reduce exposure and protect private connectivity.",
  },
  {
    to: "/halo/learn/why-post-quantum-protection-matters",
    title: "Why post-quantum protection matters",
    body: "The direction of post-quantum protection and how LightningFlow approaches resilient private connectivity.",
  },
];

export default function HaloLearnHub() {
  return (
    <>
      <SEO
        title="Learn — Halo SuperVPN"
        description="Education articles on QuantumCloak and post-quantum protection for Halo SuperVPN."
        canonicalPath="/halo/learn"
        image="/halo/official-halo-wordmark.png"
      />
      <section className="border-b border-ink-100 bg-[#031124] text-white">
        <div className="lf-container py-16 md:py-24">
          <div className="lf-eyebrow text-cyan-200">Halo SuperVPN · Learn</div>
          <h1 className="mt-5 max-w-3xl font-display text-5xl font-black md:text-6xl">Clear answers. No noise.</h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-300">
            Short guides on how Halo protects private connectivity.
          </p>
        </div>
      </section>
      <section className="lf-section">
        <div className="lf-container grid gap-4 md:grid-cols-2">
          {articles.map((article) => (
            <Link key={article.to} to={article.to} className="border border-ink-100 bg-white p-7 transition-colors hover:border-electric">
              <h2 className="font-display text-2xl font-bold">{article.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-ink-600">{article.body}</p>
              <span className="lf-link mt-6">Read <ArrowRight className="h-3.5 w-3.5" /></span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
